import "./carousel-embla-DDt0pUdq.js";
import { d as g, f as b, e as f } from "./utilities-D-QcnR4L.js";
import "./component-B88NZlIm.js";
import "./embla-tQScX_QI.js";
class v extends HTMLElement {
  #n = new IntersectionObserver(
    (e, i) => {
      e[0]?.isIntersecting && (i.disconnect(), this.#s());
    },
    { rootMargin: "0px 0px 200px 0px" }
  );
  #i = new MutationObserver((e) => {
    for (const i of e)
      if (
        !(i.target !== this || i.type !== "attributes") &&
        i.attributeName !== "data-error" &&
        !(i.attributeName === "class" && this.classList.contains("hidden")) &&
        !(
          i.attributeName === "data-recommendations-performed" &&
          this.dataset.recommendationsPerformed === "true"
        )
      ) {
        this.#s();
        break;
      }
  });
  #a = new Map();
  #e = null;
  #t;
  connectedCallback() {
    if (this.dataset.recommendationsProducts && this.dataset.recommendationsJson === "true")
      try {
        let r = this.dataset.recommendationsProducts,
          n;
        try {
          n = JSON.parse(r);
        } catch {
          const o = document.createElement("div");
          ((o.innerHTML = r), (r = o.textContent || o.innerText || r), (n = JSON.parse(r)));
        }
        const t = Array.isArray(n) ? n : n.products || [];
        if (Array.isArray(t) && t.length > 0) {
          ((this.dataset.recommendationsPerformed = "true"), this.#o(t));
          return;
        }
      } catch (r) {
        console.error("Error parsing existing recommendations products:", r);
      }
    const e = this.getBoundingClientRect();
    (e.top < window.innerHeight + 400 &&
    e.bottom > -400 &&
    e.left < window.innerWidth &&
    e.right > 0 &&
    this.dataset.recommendationsPerformed !== "true"
      ? this.#s()
      : this.#n.observe(this),
      this.#i.observe(this, { attributes: !0 }));
  }
  disconnectedCallback() {
    (this.#n.disconnect(),
      this.#i.disconnect(),
      this.#e?.abort(),
      (this.#e = null),
      this.#t !== void 0 && (clearTimeout(this.#t), (this.#t = void 0)));
  }
  loadRecommendations() {
    this.#s();
  }
  #s() {
    const {
        productId: e,
        recommendationsPerformed: i,
        sectionId: r,
        intent: n,
        manualMode: t,
      } = this.dataset,
      o = this.id;
    if (this.#e === null) {
      if (t === "true") {
        this.dataset.recommendationsPerformed = "true";
        return;
      }
      if (!e || !o) {
        (console.warn("Product recommendations: No product ID or element ID"), this.#r());
        return;
      }
      i !== "true" &&
        this.#d(e, r, n)
          .then((s) => {
            if (!s.success) {
              ((this.dataset.recommendationsPerformed = "true"),
                this.#r(),
                Shopify.designMode && console.warn(`Product recommendations failed: ${s.status}`));
              return;
            }
            if (s.isJson)
              try {
                const l = JSON.parse(s.data),
                  c = Array.isArray(l) ? l : l.products || [];
                if (Array.isArray(c)) {
                  ((this.dataset.recommendationsPerformed = "true"),
                    (this.dataset.recommendationsJson = "true"),
                    (this.dataset.recommendationsProducts = JSON.stringify(c)));
                  const m = this.querySelector(".cart-upsells-loading");
                  if ((m && m.remove(), c.length === 0)) {
                    this.dataset.recommendationsPerformed = "true";
                    const u = this.querySelector(".grid");
                    (u && (u.innerHTML = ""), this.#r());
                    const h = new CustomEvent("recommendations-json-loaded", {
                      detail: { products: [], productId: e, sectionId: r, intent: n },
                      bubbles: !0,
                      cancelable: !0,
                    });
                    this.dispatchEvent(h);
                    return;
                  }
                  this.#o(c);
                  const p = new CustomEvent("recommendations-json-loaded", {
                    detail: { products: c, productId: e, sectionId: r, intent: n },
                    bubbles: !0,
                    cancelable: !0,
                  });
                  this.dispatchEvent(p);
                  return;
                }
              } catch (l) {
                console.error("Error parsing recommendations JSON:", l);
              }
            const d = document.createElement("div");
            d.innerHTML = s.data || "";
            const a = d.querySelector(`product-recommendations[id="${o}"]`);
            a?.innerHTML && a.innerHTML.trim().length
              ? ((this.dataset.recommendationsPerformed = "true"), (this.innerHTML = a.innerHTML))
              : ((this.dataset.recommendationsPerformed = "true"),
                (this.innerHTML = ""),
                this.#r());
          })
          .catch((s) => {
            if (s?.name === "AbortError") {
              this.isConnected &&
                this.dataset.recommendationsPerformed !== "true" &&
                (clearTimeout(this.#t),
                (this.#t = window.setTimeout(() => {
                  if (this.isConnected && this.dataset.recommendationsPerformed !== "true") {
                    try {
                      this.#n.observe(this);
                    } catch {}
                    this.#s();
                  }
                }, 250)));
              return;
            }
            this.#l(s);
          });
    }
  }
  #r() {
    const e = this.closest('[data-section-type="product-recommendations"]');
    e && ((e.style.display = "none"), e.setAttribute("aria-hidden", "true"));
    const i = this.closest(".cart-upsells");
    (i && (i.style.display = "none"), (this.style.display = "none"), this.classList.add("hidden"));
  }
  async #d(e, i, r) {
    let t = `${window.Shopify?.routes?.root || "/"}recommendations/products.json`;
    const o = new URLSearchParams({
      product_id: e,
      intent: r || "related",
      limit: this.dataset.maxProducts || "8",
    });
    t = `${t}?${o.toString()}`;
    const s = this.#a.get(t);
    if (s) {
      const a = t.includes(".json") || (s.trim().startsWith("[") && s.trim().endsWith("]"));
      return { success: !0, data: s, isJson: a };
    }
    (this.#e?.abort(), (this.#e = new AbortController()));
    const d = this.#e;
    try {
      const a = await fetch(t, { signal: d.signal });
      if (!a.ok) return { success: !1, status: a.status };
      const l = a.headers.get("content-type"),
        c = await a.text(),
        m = c.trim();
      return l?.includes("application/json") ||
        t.includes(".json") ||
        (m.startsWith("[") && m.endsWith("]")) ||
        (m.startsWith("{") && m.endsWith("}"))
        ? (this.#a.set(t, c), { success: !0, data: c, isJson: !0 })
        : (this.#a.set(t, c), { success: !0, data: c, isJson: !1 });
    } finally {
      this.#e === d && (this.#e = null);
    }
  }
  #o(e) {
    const i = this.dataset.layoutType || "grid",
      r = parseInt(this.dataset.maxProducts || "4", 10),
      n = e.slice(0, r);
    if (i === "carousel") {
      let t = this.querySelector("carousel-embla");
      if (!t) {
        const s = this.querySelector(".grid");
        s && s.remove();
        const d = `
          <carousel-embla class="product-recommendations-carousel">
            <div ref="viewport" class="carousel-viewport overflow-hidden">
              <div ref="container" class="carousel-container flex gap-4"></div>
            </div>
            <div ref="controls" class="carousel-controls flex items-center justify-center gap-2 mt-4">
              <button ref="prev" class="carousel-arrow carousel-arrow--prev" aria-label="Previous">‹</button>
              <div ref="dots" class="carousel-dots flex gap-2"></div>
              <button ref="next" class="carousel-arrow carousel-arrow--next" aria-label="Next">›</button>
            </div>
          </carousel-embla>
        `,
          a = this.querySelector(".w-full");
        if (a) (a.insertAdjacentHTML("beforeend", d), (t = this.querySelector("carousel-embla")));
        else return;
      }
      const o = t.querySelector('[ref="container"]');
      if (!o) return;
      ((o.innerHTML = ""),
        n.forEach((s, d) => {
          const a = d >= 4,
            c = `<div class="carousel-slide shrink-0">${this.#c(s, a)}</div>`;
          o.insertAdjacentHTML("beforeend", c);
        }),
        t.embla
          ? t.embla.reInit()
          : typeof t.connectedCallback == "function" && t.connectedCallback());
    } else {
      const t = this.querySelector(".grid");
      if (!t) return;
      ((t.innerHTML = ""),
        n.forEach((o, s) => {
          const d = s >= 4,
            a = this.#c(o, d);
          t.insertAdjacentHTML("beforeend", a);
        }),
        t.setAttribute("data-has-recommendations", n.length > 0 ? "true" : "false"));
    }
  }
  #c(e, i = !1) {
    const r = e.variants?.[0] || e.variants?.[0],
      n =
        e.featured_image ||
        r?.featured_image?.src ||
        r?.featured_media?.preview_image?.src ||
        e.images?.[0] ||
        e.media?.[0]?.src ||
        "",
      t = n && typeof n == "string" ? (n.startsWith("//") ? `https:${n}` : n) : "",
      o = r?.price || e.price || 0,
      s = r?.compare_at_price || e.compare_at_price || null,
      d = b(o),
      a = s ? b(s) : null;
    let l = 0;
    s && s > o && (l = Math.round(((s - o) / s) * 100));
    const c = r?.available !== !1 && e.available !== !1,
      m = l > 0,
      p =
        e.tags?.includes("Topseller") ||
        e.tags?.includes("Besteseller") ||
        e.tags?.includes("Bestseller");
    let u = "";
    (c
      ? m &&
        (u +=
          '<span class="badge badge-error" role="status"><span class="sr-only">Rabatt: </span>Im Angebot</span>')
      : (u +=
          '<span class="badge badge-warning" role="status"><span class="sr-only">Status: </span>Ausverkauft</span>'),
      p &&
        (u +=
          '<span class="badge badge-primary" role="status"><span class="sr-only">Status: </span>Topseller</span>'));
    let h = "";
    return (
      a && m
        ? (h = `
        <div class="mt-2">
          <div class="flex items-center gap-x-2">
            <span class="line-through text-sm text-gray-500">${a}</span>
            <span class="font-semibold">${d}</span>
          </div>
        </div>
      `)
        : (h = `
        <div class="mt-2">
          <span class="font-semibold">${d}</span>
        </div>
      `),
      `
      <a href="${f(e.url || `/products/${e.handle}`)}" class="group block" title="${f(e.title)}">
        <div class="relative mb-4 overflow-hidden rounded-lg bg-gray-100 aspect-square">
          <div class="pointer-events-none absolute top-3 left-3 z-10 flex gap-2">
            ${u}
          </div>
          ${t ? `<img src="${f(t)}" alt="${f(e.title)}" class="w-full h-full object-contain mix-blend-multiply" ${i ? 'loading="lazy"' : ""} width="400" height="400">` : ""}
        </div>
        <span class="text-sm font-semibold">
          ${f(e.title)}
        </span>
        ${h}
      </a>
    `
    );
  }
  #l(e) {
    (console.error("Product recommendations error:", e.message),
      this.classList.add("hidden"),
      (this.dataset.error = "Error loading product recommendations"));
  }
}
g("product-recommendations", v);
